import { theme } from '@traba/theme'
import { reloadPage } from './reloadPage'

// Last-resort surface for throws before React mounts — the ErrorBoundary
// lives inside the render tree and cannot catch boot failures.
export function showBootErrorScreen() {
  const root = document.getElementById('root') ?? document.body
  root.innerHTML = `
    <div style="min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: ${theme.space.sm}px; padding: ${theme.space.med}px; font-family: ${theme.typography.fontFamily}; text-align: center;">
      <h1>Something went wrong</h1>
      <p>The app failed to start. Please reload the page.</p>
      <button id="boot-error-reload" style="padding: ${theme.space.xxs}px ${theme.space.xsmed}px; border: 1px solid ${theme.colors.Grey20}; border-radius: ${theme.border.radius}; background: ${theme.colors.White}; cursor: pointer;">Reload</button>
    </div>
  `
  document
    .getElementById('boot-error-reload')
    ?.addEventListener('click', reloadPage)
}
